import React, { useEffect, useState, UIEvent } from 'react';

import { useForm } from 'react-hook-form';

import { useTracking } from 'hooks';

import type { AuthCredentials } from 'domains/auth.d';

export const useLoginForm = () => {
  const passwordTypes = { password: 'password', text: 'text' };
  const [passwordType, setPasswordType] = useState(passwordTypes.password);
  const [canSubmit, setCanSubmit] = useState(false);
  const [isInvalidForm, setIsInvalidForm] = useState(false);
  const { register, handleSubmit, getValues, watch } = useForm<AuthCredentials>();
  const { sendDataToGTM } = useTracking();
  const MINIMUM_LENGHT = 1;
  const rules = {
    password: {
      required: true,
    },
  };

  const showPassword = (event: UIEvent<HTMLButtonElement>): void => {
    if (passwordTypes.password === passwordType) {
      setPasswordType(passwordTypes.text);

      handleTracking(event);
    } else {
      setPasswordType(passwordTypes.password);
    }
  };

  const handleTracking = (
    event: React.FocusEvent<HTMLInputElement> | UIEvent<HTMLButtonElement>
  ) => {
    const {
      currentTarget: { dataset },
    } = event;

    sendDataToGTM({
      event: 'analytics-event',
      event_parameters: {
        event_name: dataset.eventname,
        cd_interaction_detail: dataset.title,
      },
    });
  };

  useEffect(() => {
    const subscription = watch((value) => {
      if (!value.password) {
        setCanSubmit(false);
        return;
      }

      if (value.password?.length > MINIMUM_LENGHT) {
        setCanSubmit(true);
      } else {
        setCanSubmit(false);
      }
      setIsInvalidForm(false);
    });

    return () => subscription.unsubscribe();
  }, [watch]);

  return {
    canSubmit,
    passwordType,
    rules,
    isInvalidForm,
    handleTracking,
    handleSubmit,
    register,
    showPassword,
    toggleSubmit: setCanSubmit,
    toggleInvalidForm: setIsInvalidForm,
    getValues,
  };
};
